import React from 'react';

import { usePageStore } from '@client/store/pageStore/context/pageContext';
import { Grid } from '@mui/material';

import { type GroupItem, SelectGroupTree } from './SelectGroupTree';

interface GroupSelectProps {
    label?: React.ReactNode;
    disabled?: boolean;
    disabledMessage?: React.ReactNode;
}

export const GroupSelect = ({ label, disabled = false, disabledMessage }: GroupSelectProps) => {
    const {
        pageState: { formData },
        pageActions
    } = usePageStore();

    function handleChange(group: GroupItem | undefined) {
        pageActions.formData.updateFormItem({ groupId: group?.id || 'root' });
    }

    return (
        <Grid item xs={12}>
            <SelectGroupTree
                label={label}
                defaultSelected={formData.groupId as string | undefined}
                onSelect={handleChange}
                disabled={disabled}
                disabledMessage={!formData.readOnly && disabled && disabledMessage}
            />
        </Grid>
    );
};
